import classNames from 'classnames'
import { type CSSProperties, forwardRef, memo } from 'react'
import { gemIcons } from '@opallabs/constellation'
import './styles.css'
import { cssVariables, selectors } from './styleHooks'
import { type Icon2Props } from './types'

export { type Icon2Props } from './types'
export {
  publicCSSVariables as icon2CSSVariables,
  root as icon2Root,
} from './styleHooks'

/**
 * @note Use the `size` prop for numeric (px) values. Use `icon2CSSVariables.size` for other units.
 */
export const Icon2 = memo(
  forwardRef<HTMLSpanElement, Icon2Props>(
    ({ className, glyph, label, size, ...otherProps }, ref) => {
      const SVG = gemIcons[glyph]
      if (!SVG) return null

      return (
        // There needs to be a wrapper element because the underlying `<svg>` doesn't take a `ref` prop. The wrapper
        // can't be a `<div>` because this is used within `<button>`, which only allows phrasing content.
        <span
          aria-label={label}
          className={classNames(selectors.root, className)}
          data-unit={selectors.root}
          ref={ref}
          role={label === undefined ? undefined : 'img'}
          style={
            size === undefined
              ? undefined
              : ({ [cssVariables.size]: `${size}px` } as CSSProperties)
          }
          {...otherProps}
        >
          <SVG aria-hidden />
        </span>
      )
    }
  )
)
Icon2.displayName = 'Lapidary: Icon2'
